import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';
import { APP_ID, APP_VERSION } from '../../../../utils';

export const CirApi = createAsyncThunk(
  'CirApi',
  async (cirPayload, { dispatch }) => {
    dispatch({ type: 'CirApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = cirPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'creditreport_qa/get-details',
      payload: {
        customerRefNum,
        creditReportRequest: {
          tncAccepted: true,
          type: 1,
        },
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const cirRes = res;
        dispatch({ type: 'CirApi/fulfilled', payload: cirRes });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'CirApi/rejected', payload: err });
      },
    });
  }
);

export const CirApi_extrareducer = {
  [CirApi.pending]: (state, action) => {
    state.cirApiState.isLoading = true;
  },
  [CirApi.fulfilled]: (state, action) => {
    state.cirApiState.isLoading = false;
    state.cirApiState.isSuccess = true;
    state.cirApiState.isError = false;
    state.cirApiState.response = action.payload;
  },
  [CirApi.rejected]: (state, action) => {
    state.cirApiState.isLoading = false;
    state.cirApiState.isSuccess = false;
    state.cirApiState.isError = true;
    state.cirApiState.response = action.payload;
  },
};
